export default __webpack_public_path__ + "static/media/sold_en.cb7238c2.png";